import { render, staticRenderFns } from "./certificateStudentList.vue?vue&type=template&id=32fea12e"
import script from "./certificateStudentList.vue?vue&type=script&lang=js"
export * from "./certificateStudentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports